'use client'

import { usePathname } from 'next/navigation'
import { FaFacebookF } from 'react-icons/fa'
import { FaXTwitter } from 'react-icons/fa6'
import { IoLogoWhatsapp } from 'react-icons/io5'
import { FacebookShareButton, WhatsappShareButton, TwitterShareButton } from 'react-share'

import { cn } from '@/lib/utils'

interface SocialShareProps {
  title: string
  label: string
  className?: string
}

export const SocialShare = ({ title, label, className }: SocialShareProps) => {
  const pathname = usePathname()
  const baseURL =
    typeof window !== 'undefined' ? `${title}${title !== '' ? '\n\n' : ''}${window.location.origin}${pathname}` : ''

  return (
    <div className={cn('flex flex-col lg:flex-row lg:items-center gap-3', className)}>
      <h2 className="text-sm font-semibold lg:text-base">{label}</h2>
      <div className="flex items-center space-x-2">
        <FacebookShareButton url={baseURL} aria-label="Share on Facebook">
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary-blue">
            <FaFacebookF size={20} className="text-white" />
          </div>
        </FacebookShareButton>
        <TwitterShareButton url={baseURL} aria-label="Share on Twitter">
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary-blue">
            <FaXTwitter size={18} className="text-white" />
          </div>
        </TwitterShareButton>
        <WhatsappShareButton url={baseURL} aria-label="Share on WhatsApp">
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary-blue">
            <IoLogoWhatsapp size={22} className="text-white" />
          </div>
        </WhatsappShareButton>
      </div>
    </div>
  )
}
